'use client';

import { Button } from '@/components/ui/Button';
import { useStateChangeTracking } from '@/hooks/useStateChangeTracking';
import { useTranslations } from 'next-intl';

const NEXT_STEP_URL = '/sign-up/get-an-estimate';

export const IntakeV1ContinueButton = () => {
  const translations = useTranslations('SignUpPage');

  const { track } = useStateChangeTracking();

  return (
    <Button
      variant='dark'
      href={NEXT_STEP_URL}
      onClick={() =>
        track({
          source: 'intake_v1',
          stateInformation: {
            stepId: -1,
            stepIndex: -1,
            stepName: `Let's get started.`,
          },
          payload: undefined,
        })
      }
    >
      {translations('button')}
    </Button>
  );
};
